import { QarepaEnumInformation } from '@qarepa/common';

export enum EmployeeContractEnum {
  DETERMINATE = 'DETERMINATE',
  INDEFINITE = 'INDEFINITE',
  PERMANENT_SEASONAL = 'PERMANENT_SEASONAL',
  SCHOLAR = 'SCHOLAR',
  TEMPORAL = 'TEMPORAL',
}

export type EmployeeContractType =
  | EmployeeContractEnum.DETERMINATE
  | EmployeeContractEnum.INDEFINITE
  | EmployeeContractEnum.PERMANENT_SEASONAL
  | EmployeeContractEnum.SCHOLAR
  | EmployeeContractEnum.TEMPORAL;

export const EmployeeContractArray = [
  EmployeeContractEnum.DETERMINATE,
  EmployeeContractEnum.INDEFINITE,
  EmployeeContractEnum.PERMANENT_SEASONAL,
  EmployeeContractEnum.SCHOLAR,
  EmployeeContractEnum.TEMPORAL,
];

export const EmployeeContractInfo: QarepaEnumInformation<EmployeeContractEnum> =
  {
    [EmployeeContractEnum.DETERMINATE]: {
      name: $localize`Determinado`,
    },
    [EmployeeContractEnum.INDEFINITE]: {
      name: $localize`Indefinido`,
    },
    [EmployeeContractEnum.PERMANENT_SEASONAL]: {
      name: $localize`Fijo discontinuo`,
    },
    [EmployeeContractEnum.SCHOLAR]: {
      name: $localize`Becario`,
    },
    [EmployeeContractEnum.TEMPORAL]: {
      name: $localize`Temporal`,
    },
  };
